<template>
  <div>
    <b-button
      pill
      variant="outline-info"
      style="margin-left: 15px;"
      class="float-right"
      @click="handleSignClick"
    >
      Signature Needed
    </b-button>
    <b-modal
      :id="modalId"
      hide-header
      hide-footer
      centered
      content-class="shadow"
    >
      <p class="my-2">
        Please sign this with yur initials
      </p>
      <b-button @click="handleAddSignature">
        Signature
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HeartBeat_CarePlan_Block_Sign",
  components: {},
  created() {},
  beforeMount() {},
  mounted() {},
  props: {
    heartbeat: {
      type: Object,
      default: () => {
        return {};
      }
    },
    info: {
      type: Array,
      default: () => {
        return [];
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    doc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    apps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    sectionId: {
      type: String,
      default: "none"
    },
    planId: {
      type: String,
      default: "none"
    }
  },
  computed: {
    ...mapGetters({}),
    providerId() {
      return this.profile && this.profile.userId ? this.profile.userId : null;
    },
    docId() {
      return this.doc && this.doc.id ? this.doc.id : null;
    },
    modalId() {
      return `signature-modal-id-${this.doc && this.doc.id ? this.doc.id : 0}-${
        this.sectionId
      }`;
    }
  },
  methods: {
    handleSignClick() {
      this.$bvModal.show(this.modalId);
    },
    handleAddSignature() {
      const profileBy = this.profileBy();

      const signature = {
        isSigned: true,
        _created_by: profileBy,
        _created_at: new Date()
      };

      if (this.comment) signature.comment = this.comment;

      this.$store
        .dispatch("provider/addSectionTrackForProviderIdPlanIdDocId", {
          sectionId: this.sectionId,
          trackProperty: "signatures",
          payload: signature,
          providerId: this.providerId,
          planId: this.planId,
          docId: this.docId,
          updatedBy: {}
        })
        .then(({}) => {
          this.$bvModal.hide(this.modalId);
        })
        .catch(err => {});
    },
    profileBy() {
      return {
        uid: this.profile && this.profile.userId ? this.profile.userId : null,
        name: this.profile
          ? `${this.profile.firstname} ${this.profile.lastname}`
          : null,
        imgURL: this.profile ? this.profile.imgURL : null,
        comment: null
      };
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.container .vue-grid-item.vue-grid-placeholder {
  background: #c0c081;
}
</style>
